import React, { useState, useEffect } from "react";
import AddTechCardButton from "src/widgets/Button/ui/AddTechCard";
import TableTechCards from "src/features/Table/ui/TableTechCards";
import { TechCardContext } from "src/shared/lib/hooks/context/getTechCardsContext";
import { useLocation } from "react-router-dom";
import { useFetchGetTechCards } from "src/enitities/TechCards/lib/hooks/useTechCardsQuery";

export default function TableTechCardsPage({ token, websocket, initialData }) {
  const { pathname } = useLocation();
  const [data, setData] = useState(initialData || []);

  const { data: techCardsData, isLoading, refetch } = useFetchGetTechCards({
    token,
    name: undefined,
  });

  useEffect(() => {
    if (techCardsData) {
      const formattedData = techCardsData.map(techCard => ({
        ...techCard,
        items_count: techCard.items ? techCard.items.length : 0,
        created_at: techCard.created_at || new Date().toISOString(),
      }));
      setData(formattedData);
      console.log("Tech cards data loaded:", formattedData);
    }
  }, [techCardsData]);

  const refreshData = async () => {
    console.log("Manual refresh triggered at:", new Date().toISOString());
    await refetch();
  };

  return (
    <TechCardContext.Provider value={{ 
      token, 
      data, 
      loading: isLoading, 
      pathname, 
      websocket, 
      refreshData 
    }}>
      <AddTechCardButton />
      <TableTechCards />
    </TechCardContext.Provider>
  );
}